// @ts-check
/**
 * @file LegalLinks.jsx
 * @location src/components/auth/LegalLinks.jsx
 * @role 이용약관 / 개인정보처리방침 / 사업자 정보 3종 link footer.
 *
 *  현재는 자체 초안 정적 페이지(`public/legal/*.html`) 로 연결.
 *  정식 유료 출시 시점에 변호사 검토 후 내용 확정.
 */

export const LEGAL_URLS = {
  terms:    '/legal/terms.html',
  privacy:  '/legal/privacy.html',
  business: '/legal/business-info.html',
};
const URLS = LEGAL_URLS;

export function LegalLinks() {
  return (
    <div className="legal-links">
      <a href={URLS.terms}    target="_blank" rel="noopener noreferrer">이용약관</a>
      <span>·</span>
      <a href={URLS.privacy}  target="_blank" rel="noopener noreferrer">개인정보처리방침</a>
      <span>·</span>
      <a href={URLS.business} target="_blank" rel="noopener noreferrer">사업자 정보</a>
    </div>
  );
}
